(function () {
  function moneyFromCents(cents) {
    return new Intl.NumberFormat(undefined, { style: 'currency', currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'PKR' }).format(cents / 100);
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-ah-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
    document.querySelectorAll('[data-ah-drawer-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function colorHexFromName(name) {
    var v = String(name || '').toLowerCase();
    if (v.indexOf('black') !== -1) return '#1a1a1a';
    if (/maroon|wine|burgundy/.test(v)) return '#5a1a1f';
    if (/brown|chocolate|cognac/.test(v)) return '#5c3a24';
    if (/beige|skin|cream|sand|fawn|tan|camel|ivory/.test(v)) return '#e8d7c0';
    if (v.indexOf('white') !== -1) return '#f4f1ea';
    if (/green|olive/.test(v)) return '#2f4a34';
    if (v.indexOf('navy') !== -1) return '#1c2740';
    if (v.indexOf('pink') !== -1) return '#c97b8a';
    if (v.indexOf('blue') !== -1) return '#3a5a7c';
    if (/mustard|gold/.test(v)) return '#c4a035';
    if (v.indexOf('red') !== -1) return '#8b1e1e';
    return '#c4a882';
  }

  function colorLabelFromTitle(title, base) {
    var rest = String(title || '').slice(String(base || '').length).trim();
    return rest || title;
  }

  function initColorPalettes() {
    var nodes = document.querySelectorAll('[data-ah-color-family]');
    if (!nodes.length) return;

    var cache = {};

    nodes.forEach(function (el) {
      var base = (el.getAttribute('data-ah-color-family') || '').trim();
      var current = (el.getAttribute('data-ah-color-current') || '').trim();
      var mode = el.getAttribute('data-ah-color-mode') || 'card';
      if (!base || el.getAttribute('data-ah-colors-loaded') === '1') return;

      var existing = el.querySelectorAll('a').length;
      /* Always refresh from backend so homepage / partial Liquid lists stay complete */
      var req = cache[base] || (cache[base] = fetch(
        '/search/suggest.json?q=' + encodeURIComponent(base) + '&resources[type]=product&resources[limit]=10'
      ).then(function (r) { return r.json(); }).catch(function () { return null; }));

      req.then(function (data) {
        if (!data || !data.resources || !data.resources.results) return;
        var products = data.resources.results.products || [];
        var siblings = products.filter(function (p) {
          var t = (p.title || '').trim();
          return t === base || t.indexOf(base + ' ') === 0;
        });
        if (!siblings.length) {
          el.setAttribute('data-ah-colors-loaded', '1');
          return;
        }

        var html = '';
        siblings.forEach(function (p) {
          var handle = p.handle || '';
          var url = (p.url || ('/products/' + handle)).split('?')[0];
          var img = (p.featured_image && p.featured_image.url) || p.image || '';
          var label = colorLabelFromTitle(p.title, base);
          var hex = colorHexFromName(label);
          var active = handle === current || (p.url && p.url.indexOf('/products/' + current) !== -1);
          var style = img
            ? 'background-image:url(' + img + ');background-size:cover;background-position:center;'
            : 'background:' + hex + ';';
          if (mode === 'pdp') {
            html += '<a class="ap-swatch' + (active ? ' is-active' : '') + '" href="' + escapeHtml(url) + '" style="' + style + '" aria-label="' + escapeHtml(label) + '" title="' + escapeHtml(p.title) + '"></a>';
          } else {
            html += '<a class="ah-card__dot' + (active ? ' is-active' : '') + '" href="' + escapeHtml(url) + '" style="' + style + '" title="' + escapeHtml(p.title) + '"></a>';
          }
        });

        if (html && (siblings.length >= existing || existing === 0)) {
          el.innerHTML = html;
        }
        el.setAttribute('data-ah-colors-loaded', '1');
      });
    });
  }

  var cartDrawer = {
    root: null,
    open: function () {
      if (!cartDrawer.root) return;
      cartDrawer.root.hidden = false;
      requestAnimationFrame(function () {
        cartDrawer.root.classList.add('is-open');
      });
      document.documentElement.style.overflow = 'hidden';
      var panel = cartDrawer.root.querySelector('.ah-drawer__panel');
      if (panel) panel.focus();
    },
    close: function () {
      if (!cartDrawer.root) return;
      cartDrawer.root.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      setTimeout(function () {
        if (!cartDrawer.root.classList.contains('is-open')) {
          cartDrawer.root.hidden = true;
        }
      }, 320);
    },
    setBusy: function (on) {
      if (cartDrawer.root) cartDrawer.root.classList.toggle('is-busy', on);
    },
    render: function (cart) {
      if (!cartDrawer.root || !cart) return;
      updateCartCount(cart.item_count || 0);

      var body = cartDrawer.root.querySelector('[data-ah-drawer-body]');
      var foot = cartDrawer.root.querySelector('[data-ah-drawer-foot]');
      var shopAll = '/collections/all';

      if (!cart.item_count) {
        if (body) {
          body.innerHTML =
            '<div class="ah-drawer__empty" data-ah-drawer-empty>' +
            '<p>Your bag is empty</p>' +
            '<a href="' + shopAll + '" data-ah-drawer-close>Continue shopping</a></div>';
        }
        if (foot) foot.hidden = true;
        return;
      }

      if (foot) foot.hidden = false;

      var itemsHtml = (cart.items || []).map(function (item) {
        var img = item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.product_title) + '">' : '';
        var variant = item.variant_title && item.variant_title !== 'Default Title'
          ? '<p class="ah-drawer__variant">' + escapeHtml(item.variant_title) + '</p>'
          : '';
        var compare = item.original_line_price > item.final_line_price
          ? '<s>' + formatMoney(item.original_line_price) + '</s>'
          : '';
        return (
          '<li class="ah-drawer__item" data-key="' + escapeHtml(item.key) + '">' +
            '<a class="ah-drawer__thumb" href="' + escapeHtml(item.url) + '">' + img + '</a>' +
            '<div class="ah-drawer__meta">' +
              '<div class="ah-drawer__row">' +
                '<a class="ah-drawer__name" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>' +
                '<button type="button" class="ah-drawer__remove" data-ah-drawer-remove data-key="' + escapeHtml(item.key) + '" aria-label="Remove">×</button>' +
              '</div>' +
              variant +
              '<div class="ah-drawer__price"><strong>' + formatMoney(item.final_line_price) + '</strong>' + compare + '</div>' +
              '<div class="ah-drawer__qty" data-ah-drawer-qty data-key="' + escapeHtml(item.key) + '">' +
                '<button type="button" data-dir="-" aria-label="Decrease">−</button>' +
                '<span data-qty>' + item.quantity + '</span>' +
                '<button type="button" data-dir="+" aria-label="Increase">+</button>' +
              '</div>' +
            '</div>' +
          '</li>'
        );
      }).join('');

      if (body) {
        body.innerHTML = '<ul class="ah-drawer__items" data-ah-drawer-items>' + itemsHtml + '</ul>';
      }

      var money = formatMoney(cart.total_price);
      var sub = formatMoney(cart.items_subtotal_price);
      cartDrawer.root.querySelectorAll('[data-ah-drawer-subtotal]').forEach(function (el) {
        el.textContent = sub;
      });
      cartDrawer.root.querySelectorAll('[data-ah-drawer-total], [data-ah-drawer-total-foot]').forEach(function (el) {
        el.textContent = money;
      });
    },
    changeQty: function (key, quantity) {
      if (!key) return Promise.resolve();
      cartDrawer.setBusy(true);
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
      })
        .then(parseJsonResponse)
        .then(function (cart) {
          cartDrawer.render(cart);
          return cart;
        })
        .catch(function () {
          return fetch('/cart.js').then(parseJsonResponse).then(cartDrawer.render);
        })
        .then(function () {
          cartDrawer.setBusy(false);
        });
    },
    refresh: function () {
      return fetch('/cart.js')
        .then(parseJsonResponse)
        .then(function (cart) {
          cartDrawer.render(cart);
          return cart;
        });
    }
  };

  function initCartDrawer() {
    cartDrawer.root = document.querySelector('[data-ah-drawer]');
    if (!cartDrawer.root) return;

    cartDrawer.root.querySelectorAll('[data-ah-drawer-close]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        cartDrawer.close();
      });
    });

    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-ah-drawer-open]');
      if (openBtn) {
        e.preventDefault();
        cartDrawer.refresh().then(cartDrawer.open).catch(cartDrawer.open);
        return;
      }

      if (!cartDrawer.root || cartDrawer.root.hidden) return;

      var removeBtn = e.target.closest('[data-ah-drawer-remove]');
      if (removeBtn && cartDrawer.root.contains(removeBtn)) {
        e.preventDefault();
        cartDrawer.changeQty(removeBtn.getAttribute('data-key'), 0);
        return;
      }

      var qtyBtn = e.target.closest('[data-ah-drawer-qty] button');
      if (qtyBtn && cartDrawer.root.contains(qtyBtn)) {
        e.preventDefault();
        var wrap = qtyBtn.closest('[data-ah-drawer-qty]');
        var qtyEl = wrap.querySelector('[data-qty]');
        var qty = parseInt(qtyEl.textContent, 10) || 1;
        qty += qtyBtn.getAttribute('data-dir') === '-' ? -1 : 1;
        cartDrawer.changeQty(wrap.getAttribute('data-key'), Math.max(0, qty));
        return;
      }

      var emptyClose = e.target.closest('[data-ah-drawer-close]');
      if (emptyClose && cartDrawer.root.contains(emptyClose)) {
        cartDrawer.close();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && cartDrawer.root && !cartDrawer.root.hidden) {
        cartDrawer.close();
      }
    });
  }

  function formatMoney(cents) {
    try {
      return moneyFromCents(cents);
    } catch (e) {
      return 'Rs ' + (Math.round(cents) / 100).toLocaleString();
    }
  }

  function parseJsonResponse(res) {
    return res.text().then(function (text) {
      var data = null;
      try { data = text ? JSON.parse(text) : null; } catch (e) { data = null; }
      if (!res.ok) {
        var err = new Error((data && data.description) || ('Request failed (' + res.status + ')'));
        err.status = res.status;
        err.payload = data;
        throw err;
      }
      return data;
    });
  }

  function setCodCartIntent(extra) {
    var attributes = {
      payment_method: 'Cash on Delivery'
    };
    var note = 'Cash on Delivery';
    if (extra) {
      Object.keys(extra.attributes || {}).forEach(function (k) {
        var val = extra.attributes[k];
        if (val === undefined || val === null || val === '') return;
        attributes[k] = String(val);
      });
      if (extra.note) note = extra.note;
    }
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: note, attributes: attributes })
    }).then(parseJsonResponse);
  }

  function wait(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  function addCodItem(variantId, quantity, properties) {
    var payload = {
      id: Number(variantId),
      quantity: quantity
    };
    if (properties && Object.keys(properties).length) {
      payload.properties = properties;
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(parseJsonResponse);
  }

  function fallbackCodCheckout(variantId, quantity, note, attributes) {
    return setCodCartIntent({ note: note, attributes: attributes }).catch(function () {
      return null;
    }).then(function () {
      var form = document.createElement('form');
      form.method = 'post';
      form.action = '/cart/add';
      form.style.display = 'none';
      function addField(name, value) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        form.appendChild(input);
      }
      addField('id', String(variantId));
      addField('quantity', String(quantity));
      addField('return_to', '/checkout');
      addField('properties[Payment]', attributes.payment_method || 'Cash on Delivery');
      if (attributes.cod_phone) addField('properties[Phone]', attributes.cod_phone);
      if (attributes.cod_city) addField('properties[City]', attributes.cod_city);
      document.body.appendChild(form);
      form.submit();
    });
  }

  function initCodModal() {
    var modal = document.querySelector('[data-ap-cod-modal]');
    if (!modal) return;

    var form = modal.querySelector('[data-ap-cod-form]');
    var qtyVal = modal.querySelector('[data-ap-cod-qty-val]');
    var badge = modal.querySelector('[data-ap-cod-badge]');
    var unitEl = modal.querySelector('[data-ap-cod-unit-price]');
    var subtotalEl = modal.querySelector('[data-ap-cod-subtotal]');
    var totalEl = modal.querySelector('[data-ap-cod-total]');
    var submitTotalEl = modal.querySelector('[data-ap-cod-submit-total]');
    var errorEl = modal.querySelector('[data-ap-cod-error]');
    var submitBtn = modal.querySelector('[data-ap-cod-submit]');
    var unitCents = unitEl ? parseInt(unitEl.getAttribute('data-cents'), 10) || 0 : 0;
    var qty = 1;

    function syncTotals() {
      var total = unitCents * qty;
      if (qtyVal) qtyVal.textContent = String(qty);
      if (badge) badge.textContent = String(qty);
      var money = formatMoney(total);
      if (subtotalEl) subtotalEl.textContent = money;
      if (totalEl) totalEl.textContent = money;
      if (submitTotalEl) submitTotalEl.textContent = money;
      var pdpQty = document.querySelector('.ap-buy [data-ap-qty] input[name="quantity"]');
      if (pdpQty) pdpQty.value = String(qty);
    }

    function openModal() {
      var pdpQty = document.querySelector('.ap-buy [data-ap-qty] input[name="quantity"]');
      qty = Math.max(1, parseInt(pdpQty && pdpQty.value, 10) || 1);
      syncTotals();
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }
      modal.querySelectorAll('.is-invalid').forEach(function (el) {
        el.classList.remove('is-invalid');
      });
      if (typeof modal.showModal === 'function') modal.showModal();
      else modal.setAttribute('open', '');
      document.documentElement.style.overflow = 'hidden';
    }

    function closeModal() {
      if (typeof modal.close === 'function') modal.close();
      else modal.removeAttribute('open');
      document.documentElement.style.overflow = '';
    }

    document.querySelectorAll('[data-ap-cod-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.disabled) return;
        openModal();
      });
    });

    modal.querySelectorAll('[data-ap-cod-close]').forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });

    modal.querySelectorAll('[data-ap-cod-qty] button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        qty += btn.getAttribute('data-dir') === '-' ? -1 : 1;
        qty = Math.max(1, qty);
        syncTotals();
      });
    });

    function collectAddress() {
      var data = new FormData(form);
      return {
        first_name: (data.get('first_name') || '').toString().trim(),
        last_name: (data.get('last_name') || '').toString().trim(),
        phone: (data.get('phone') || '').toString().trim(),
        address: (data.get('address') || '').toString().trim(),
        landmark: (data.get('landmark') || '').toString().trim(),
        city: (data.get('city') || '').toString().trim(),
        email: (data.get('email') || '').toString().trim()
      };
    }

    function validate(addr) {
      var ok = true;
      [['first_name', addr.first_name], ['phone', addr.phone], ['address', addr.address], ['city', addr.city]].forEach(function (pair) {
        var input = form.querySelector('[name="' + pair[0] + '"]');
        var valid = !!pair[1];
        if (pair[0] === 'phone') valid = /^[0-9+\s-]{10,15}$/.test(pair[1]);
        if (input) input.classList.toggle('is-invalid', !valid);
        if (!valid) ok = false;
      });
      return ok;
    }

    function placeOrder(prepaid) {
      var addr = collectAddress();
      if (!prepaid && !validate(addr)) {
        if (errorEl) {
          errorEl.hidden = false;
          errorEl.textContent = 'Please fill all required fields correctly.';
        }
        return;
      }

      var variantInput = form.querySelector('[data-ap-cod-variant]');
      var variantId = variantInput ? variantInput.value : '';
      if (!variantId) return;

      submitBtn.disabled = true;
      if (errorEl) errorEl.hidden = true;

      var noteLines = [
        prepaid ? 'Payment: Prepaid checkout' : 'Payment: Cash on Delivery',
        'Name: ' + [addr.first_name, addr.last_name].filter(Boolean).join(' '),
        'Phone: ' + addr.phone,
        'Address: ' + addr.address,
        addr.landmark ? 'Landmark: ' + addr.landmark : '',
        'City: ' + addr.city,
        addr.email ? 'Email: ' + addr.email : ''
      ].filter(Boolean).join('\n');

      var attributes = {
        payment_method: prepaid ? 'Prepaid' : 'Cash on Delivery',
        cod_first_name: addr.first_name,
        cod_last_name: addr.last_name,
        cod_phone: addr.phone,
        cod_address: addr.address,
        cod_landmark: addr.landmark,
        cod_city: addr.city,
        cod_email: addr.email
      };

      var properties = prepaid ? null : {
        Payment: 'Cash on Delivery',
        Phone: addr.phone,
        City: addr.city
      };

      var apiUrl = (modal.getAttribute('data-ap-cod-api') || '').trim();
      var apiSecret = (modal.getAttribute('data-ap-cod-secret') || '').trim();
      var thanksUrl = (modal.getAttribute('data-ap-cod-thanks') || '/pages/order-received').trim();

      // Direct order placement (no Shopify checkout) when COD API is configured
      if (!prepaid && apiUrl) {
        var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
        if (apiSecret) headers['X-ARBO-COD-Secret'] = apiSecret;
        fetch(apiUrl, {
          method: 'POST',
          headers: headers,
          body: JSON.stringify({
            variant_id: variantId,
            quantity: qty,
            first_name: addr.first_name,
            last_name: addr.last_name,
            phone: addr.phone,
            address: addr.address,
            landmark: addr.landmark,
            city: addr.city,
            email: addr.email
          })
        })
          .then(function (r) {
            return r.json().then(function (data) {
              if (!r.ok || !data || !data.ok) {
                throw new Error((data && data.error) || 'Order failed');
              }
              return data;
            });
          })
          .then(function (data) {
            var orderName = data.order_name || '';
            if (data.status_url) {
              window.location.href = data.status_url;
              return;
            }
            window.location.href = thanksUrl + (orderName ? ('?order=' + encodeURIComponent(orderName)) : '');
          })
          .catch(function (err) {
            submitBtn.disabled = false;
            if (errorEl) {
              errorEl.hidden = false;
              errorEl.textContent = (err && err.message) ? err.message : 'Could not place order. Please try again.';
            }
          });
        return;
      }

      function runCheckout(attempt) {
        return addCodItem(variantId, qty, properties)
          .catch(function (err) {
            if (err && err.status === 429 && attempt < 2) {
              return wait(1600).then(function () { return addCodItem(variantId, qty, properties); });
            }
            throw err;
          })
          .then(function () {
            return setCodCartIntent({ note: noteLines, attributes: attributes });
          })
          .then(function () {
            window.location.href = '/checkout';
          });
      }

      runCheckout(1).catch(function (err) {
        if (err && err.status === 429) {
          return wait(1800).then(function () {
            return fallbackCodCheckout(variantId, qty, noteLines, attributes);
          });
        }
        return fallbackCodCheckout(variantId, qty, noteLines, attributes);
      }).catch(function () {
        submitBtn.disabled = false;
        if (errorEl) {
          errorEl.hidden = false;
          errorEl.textContent = 'Please wait a moment and try again.';
        }
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      placeOrder(false);
    });

    var prepaidBtn = modal.querySelector('[data-ap-cod-prepaid]');
    if (prepaidBtn) {
      prepaidBtn.addEventListener('click', function () {
        placeOrder(true);
      });
    }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-ah-atc-form], .ap-buy form, .ah-card__form');
    if (!form || form.getAttribute('action') && form.getAttribute('action').indexOf('/cart/add') === -1 && !form.querySelector('[name="id"]')) return;
    if (!form.querySelector('[name="id"]')) return;
    if (form.hasAttribute('data-ap-cod-form') || e.target.closest('[data-ap-cod-form]')) return;
    e.preventDefault();
    var submitter = e.submitter || document.activeElement;
    if (submitter && submitter.getAttribute && submitter.getAttribute('data-ap-cod-open') !== null) return;
    var data = new FormData(form);
    var addReq = fetch('/cart/add.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });

    addReq
      .then(function () { return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        cartDrawer.render(cart);
        cartDrawer.open();
        var btn = form.querySelector('.ap-cta--atc, button[type="submit"]');
        if (btn && !btn.hasAttribute('data-ap-cod-open')) {
          var prev = btn.textContent;
          btn.textContent = 'Added';
          setTimeout(function () { btn.textContent = prev; }, 1200);
        }
      })
      .catch(function () { form.submit(); });
  });

  document.addEventListener('DOMContentLoaded', function () {
    initCartDrawer();
    initExitPopup();
    initCodModal();
    initColorPalettes();

    var menu = document.querySelector('[data-ah-site-menu]');
    var nav = document.querySelector('[data-ah-site-nav]');
    if (menu && nav) {
      menu.addEventListener('click', function () { nav.classList.toggle('is-open'); });
    }

    function closeOpenMenus() {
      if (nav) nav.classList.remove('is-open');
      document.querySelectorAll('.ah-nav.is-open').forEach(function (el) {
        el.classList.remove('is-open');
      });
      document.querySelectorAll('[data-ah-menu].is-open').forEach(function (el) {
        el.classList.remove('is-open');
      });
      document.querySelectorAll('[data-ah-nav-drop].is-open').forEach(function (drop) {
        drop.classList.remove('is-open');
        var dropBtn = drop.querySelector('[data-ah-nav-drop-btn]');
        if (dropBtn) dropBtn.setAttribute('aria-expanded', 'false');
      });
    }

    document.querySelectorAll('[data-ah-nav-drop]').forEach(function (drop) {
      var btn = drop.querySelector('[data-ah-nav-drop-btn]');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var open = drop.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.querySelectorAll('[data-ah-nav-drop].is-open').forEach(function (other) {
          if (other !== drop) {
            other.classList.remove('is-open');
            var otherBtn = other.querySelector('[data-ah-nav-drop-btn]');
            if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
          }
        });
      });
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-ah-nav-drop]')) return;
      document.querySelectorAll('[data-ah-nav-drop].is-open').forEach(function (drop) {
        drop.classList.remove('is-open');
        var btn = drop.querySelector('[data-ah-nav-drop-btn]');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    });

    window.addEventListener('scroll', closeOpenMenus, { passive: true });
    document.addEventListener('scroll', closeOpenMenus, { passive: true, capture: true });

    document.querySelectorAll('[data-ah-acc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.parentElement.classList.toggle('is-open');
      });
    });

    var gallery = document.querySelector('[data-ap-gallery]');
    if (gallery) {
      var main = gallery.querySelector('[data-ap-main]');
      var thumbs = gallery.querySelectorAll('[data-ap-thumb]');
      var idx = 0;
      var zoomScale = 1;
      var zoomX = 0;
      var zoomY = 0;
      var dragging = false;
      var dragStartX = 0;
      var dragStartY = 0;
      var originX = 0;
      var originY = 0;

      function currentZoomSrc() {
        if (thumbs.length) {
          var t = thumbs[idx] || thumbs[0];
          return t.getAttribute('data-zoom-src') || t.getAttribute('data-src') || (main && main.src);
        }
        return (main && (main.getAttribute('data-zoom-src') || main.src)) || '';
      }

      function show(i) {
        if (!thumbs.length) return;
        idx = (i + thumbs.length) % thumbs.length;
        var src = thumbs[idx].getAttribute('data-src');
        var zoomSrc = thumbs[idx].getAttribute('data-zoom-src') || src;
        if (main && src) {
          main.src = src;
          if (zoomSrc) main.setAttribute('data-zoom-src', zoomSrc);
        }
        thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === idx); });
      }
      thumbs.forEach(function (t, n) {
        t.addEventListener('click', function () { show(n); });
      });
      var prev = gallery.querySelector('[data-ap-prev]');
      var next = gallery.querySelector('[data-ap-next]');
      if (prev) prev.addEventListener('click', function () { show(idx - 1); });
      if (next) next.addEventListener('click', function () { show(idx + 1); });

      var zoomRoot = document.querySelector('[data-ap-zoom-root]');
      if (!zoomRoot) {
        zoomRoot = document.createElement('div');
        zoomRoot.className = 'ap-zoom';
        zoomRoot.setAttribute('data-ap-zoom-root', '');
        zoomRoot.hidden = true;
        zoomRoot.innerHTML =
          '<div class="ap-zoom__inner" data-ap-zoom-inner>' +
            '<img class="ap-zoom__img" data-ap-zoom-img alt="">' +
          '</div>' +
          '<button type="button" class="ap-zoom__close" data-ap-zoom-close aria-label="Close zoom">×</button>' +
          '<button type="button" class="ap-zoom__in" data-ap-zoom-in aria-label="Zoom in">+</button>' +
          '<button type="button" class="ap-zoom__out" data-ap-zoom-out aria-label="Zoom out">−</button>';
        document.body.appendChild(zoomRoot);
      }

      var zoomImg = zoomRoot.querySelector('[data-ap-zoom-img]');
      var zoomInner = zoomRoot.querySelector('[data-ap-zoom-inner]');

      function applyZoomTransform() {
        if (!zoomImg) return;
        zoomImg.style.transform = 'translate(' + zoomX + 'px,' + zoomY + 'px) scale(' + zoomScale + ')';
        if (zoomInner) {
          zoomInner.classList.toggle('is-zoomed', zoomScale > 1);
        }
      }

      function setZoom(next) {
        zoomScale = Math.max(1, Math.min(4, next));
        if (zoomScale === 1) {
          zoomX = 0;
          zoomY = 0;
        }
        applyZoomTransform();
      }

      function openZoom() {
        var src = currentZoomSrc();
        if (!src || !zoomImg) return;
        zoomImg.src = src;
        zoomImg.alt = (main && main.alt) || 'Product image';
        setZoom(1);
        zoomRoot.hidden = false;
        requestAnimationFrame(function () {
          zoomRoot.classList.add('is-open');
        });
        document.documentElement.style.overflow = 'hidden';
      }

      function closeZoom() {
        zoomRoot.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        setTimeout(function () {
          if (!zoomRoot.classList.contains('is-open')) zoomRoot.hidden = true;
        }, 200);
        setZoom(1);
      }

      var zoomBtn = gallery.querySelector('[data-ap-zoom]');
      if (zoomBtn) zoomBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openZoom();
      });
      if (main) {
        main.addEventListener('click', function () { openZoom(); });
      }

      var closeBtn = zoomRoot.querySelector('[data-ap-zoom-close]');
      var zoomInBtn = zoomRoot.querySelector('[data-ap-zoom-in]');
      var zoomOutBtn = zoomRoot.querySelector('[data-ap-zoom-out]');
      if (closeBtn) closeBtn.addEventListener('click', closeZoom);
      if (zoomInBtn) zoomInBtn.addEventListener('click', function () { setZoom(zoomScale + 0.5); });
      if (zoomOutBtn) zoomOutBtn.addEventListener('click', function () { setZoom(zoomScale - 0.5); });

      zoomRoot.addEventListener('click', function (e) {
        if (e.target === zoomRoot) closeZoom();
      });

      if (zoomInner) {
        zoomInner.addEventListener('click', function (e) {
          e.stopPropagation();
          if (zoomScale === 1) setZoom(2);
          else setZoom(1);
        });

        zoomInner.addEventListener('pointerdown', function (e) {
          if (zoomScale <= 1) return;
          dragging = true;
          dragStartX = e.clientX;
          dragStartY = e.clientY;
          originX = zoomX;
          originY = zoomY;
          zoomInner.classList.add('is-dragging');
          zoomInner.setPointerCapture(e.pointerId);
        });
        zoomInner.addEventListener('pointermove', function (e) {
          if (!dragging) return;
          zoomX = originX + (e.clientX - dragStartX);
          zoomY = originY + (e.clientY - dragStartY);
          applyZoomTransform();
        });
        function endDrag(e) {
          if (!dragging) return;
          dragging = false;
          zoomInner.classList.remove('is-dragging');
          try { zoomInner.releasePointerCapture(e.pointerId); } catch (err) {}
        }
        zoomInner.addEventListener('pointerup', endDrag);
        zoomInner.addEventListener('pointercancel', endDrag);
      }

      document.addEventListener('keydown', function (e) {
        if (!zoomRoot.classList.contains('is-open')) return;
        if (e.key === 'Escape') closeZoom();
        if (e.key === '+' || e.key === '=') setZoom(zoomScale + 0.5);
        if (e.key === '-' || e.key === '_') setZoom(zoomScale - 0.5);
      });
    }

    document.querySelectorAll('[data-ap-qty]').forEach(function (qty) {
      var input = qty.querySelector('input');
      if (!input) return;
      var min = parseInt(input.getAttribute('min'), 10);
      if (isNaN(min)) min = 1;
      qty.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = parseInt(input.value, 10);
          if (isNaN(n)) n = min;
          n += b.getAttribute('data-dir') === '-' ? -1 : 1;
          input.value = Math.max(min, n);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

    initCartPage();

    /* ——— Recently viewed → You may also like (live Shopify fetch) ——— */
    var VIEWED_KEY = 'arbo-recently-viewed';
    var VIEWED_MAX = 12;

    function readViewedHandles() {
      try {
        var list = JSON.parse(localStorage.getItem(VIEWED_KEY) || '[]');
        return Array.isArray(list) ? list.filter(Boolean) : [];
      } catch (e) {
        return [];
      }
    }

    function writeViewedHandles(list) {
      try {
        localStorage.setItem(VIEWED_KEY, JSON.stringify(list.slice(0, VIEWED_MAX)));
      } catch (e) {}
    }

    function trackProductView(handle) {
      if (!handle) return;
      var list = readViewedHandles().filter(function (h) { return h !== handle; });
      list.unshift(handle);
      writeViewedHandles(list);
    }

    function moneyLabel(price) {
      var raw = String(price == null ? '' : price);
      var n = parseFloat(raw);
      if (isNaN(n)) return '';
      /* product.js → cents (int); products.json → major units ("3499.00") */
      if (raw.indexOf('.') === -1) n = n / 100;
      return 'Rs. ' + Math.round(n).toLocaleString('en-PK');
    }

    function cardHtmlFromProduct(p) {
      if (!p || !p.handle) return '';
      var img = '';
      if (p.featured_image) {
        img = typeof p.featured_image === 'string' ? p.featured_image : (p.featured_image.src || '');
      } else if (p.images && p.images[0]) {
        img = typeof p.images[0] === 'string' ? p.images[0] : (p.images[0].src || '');
      }
      var variant = (p.variants && p.variants[0]) || {};
      var price = variant.price != null ? variant.price : p.price;
      var compare = variant.compare_at_price;
      var available = p.available !== false && variant.available !== false;
      var title = escapeHtml(p.title || '');
      var url = '/products/' + encodeURIComponent(p.handle);
      var priceHtml = '';
      if (compare && parseFloat(compare) > parseFloat(price)) {
        priceHtml = '<span class="ah-card__compare">' + escapeHtml(moneyLabel(compare)) + '</span>';
      }
      priceHtml += '<span class="ah-card__sale">' + escapeHtml(moneyLabel(price)) + '</span>';
      return (
        '<article class="ah-card">' +
          '<a class="ah-card__media" href="' + url + '">' +
            (img ? '<img class="ah-card__img" src="' + escapeHtml(img) + '" alt="' + title + '" loading="lazy" decoding="async">' : '') +
          '</a>' +
          '<div class="ah-card__info">' +
            '<h3 class="ah-card__name"><a href="' + url + '">' + title + '</a></h3>' +
            '<p class="ah-card__price">' + priceHtml + '</p>' +
            (available
              ? '<form class="ah-card__form" action="/cart/add" method="post"><input type="hidden" name="id" value="' + escapeHtml(variant.id) + '"><button type="submit" class="ah-card__atc">Add to cart</button></form>'
              : '<button type="button" class="ah-card__atc" disabled>Sold out</button>') +
          '</div>' +
        '</article>'
      );
    }

    function fetchProductByHandle(handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) {
          if (!r.ok) throw new Error('missing');
          return r.json();
        });
    }

    function fetchCollectionProducts(handle, limit) {
      var h = handle || 'all';
      return fetch('/collections/' + encodeURIComponent(h) + '/products.json?limit=' + (limit || 12))
        .then(function (r) { return r.json(); })
        .then(function (data) { return data.products || []; })
        .catch(function () { return []; });
    }

    function fillRelatedTrack(track, products, limit) {
      var html = products.slice(0, limit).map(cardHtmlFromProduct).join('');
      if (html) track.innerHTML = html;
    }

    var related = document.querySelector('[data-ap-related]');
    if (related) {
      var currentId = related.getAttribute('data-product-id') || '';
      var currentHandle = related.getAttribute('data-product-handle') || '';
      var limit = parseInt(related.getAttribute('data-limit'), 10) || 5;
      var fallbackColl = related.getAttribute('data-fallback-collection') || 'all';
      var track = related.querySelector('[data-ap-related-track]') || related.querySelector('.ap-related__track');

      if (currentHandle) trackProductView(currentHandle);

      if (track) {
        var viewed = readViewedHandles().filter(function (h) { return h !== currentHandle; }).slice(0, limit);

        function loadFallback() {
          var sectionId = related.getAttribute('data-section-id');
          if (currentId && sectionId) {
            var recUrl = '/recommendations/products?product_id=' + currentId +
              '&section_id=' + sectionId + '&limit=' + limit;
            return fetch(recUrl)
              .then(function (r) { return r.text(); })
              .then(function (html) {
                var doc = new DOMParser().parseFromString(html, 'text/html');
                var src = doc.querySelector('.ap-related__track');
                if (src && src.children.length) {
                  track.innerHTML = src.innerHTML;
                  return true;
                }
                return false;
              })
              .catch(function () { return false; })
              .then(function (ok) {
                if (ok) return;
                return fetchCollectionProducts(fallbackColl, limit + 4).then(function (products) {
                  var filtered = products.filter(function (p) {
                    return String(p.id) !== String(currentId) && p.handle !== currentHandle;
                  });
                  fillRelatedTrack(track, filtered, limit);
                });
              });
          }
          return fetchCollectionProducts(fallbackColl, limit + 4).then(function (products) {
            var filtered = products.filter(function (p) {
              return String(p.id) !== String(currentId) && p.handle !== currentHandle;
            });
            fillRelatedTrack(track, filtered, limit);
          });
        }

        if (viewed.length) {
          Promise.all(viewed.map(function (h) {
            return fetchProductByHandle(h).catch(function () { return null; });
          })).then(function (results) {
            var products = results.filter(function (p) {
              return p && p.handle && p.handle !== currentHandle && String(p.id) !== String(currentId);
            });
            if (products.length) {
              fillRelatedTrack(track, products, limit);
            } else {
              loadFallback();
            }
          });
        } else {
          loadFallback();
        }
      }
    }

    var wishGrid = document.querySelector('[data-ap-wish-grid]');
    if (wishGrid) {
      var ids = [];
      try { ids = JSON.parse(localStorage.getItem('arbo-wish') || '[]'); } catch (e) {}
      if (!ids.length) {
        wishGrid.innerHTML = '<div class="ah-empty"><p>No saved bags yet.</p><div class="ah-empty__ctas"><a class="ap-atc ah-btn" href="/collections/all">Shop all bags</a></div></div>';
      } else {
        fetch('/collections/all/products.json?limit=250')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var wanted = {};
            ids.forEach(function (id) { wanted[String(id)] = true; });
            var matches = (data.products || []).filter(function (p) { return wanted[String(p.id)]; });
            if (!matches.length) {
              wishGrid.innerHTML = '<div class="ah-empty"><p>Saved bags are no longer available.</p></div>';
              return;
            }
            wishGrid.innerHTML = matches.map(function (p) {
              var img = p.images && p.images[0] ? p.images[0].src : '';
              var price = p.variants && p.variants[0] ? p.variants[0].price : '';
              return '<article class="ah-card"><a class="ah-card__media" href="/products/' + p.handle + '">' +
                (img ? '<img src="' + img + '" alt="' + p.title.replace(/"/g, '&quot;') + '">' : '') +
                '</a><div class="ah-card__info"><h3 class="ah-card__name"><a href="/products/' + p.handle + '">' + p.title +
                '</a></h3><p class="ah-card__price">Rs.' + price + '</p></div></article>';
            }).join('');
          })
          .catch(function () {});
      }
    }

    document.querySelectorAll('[data-ap-wish]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-id');
        var list = [];
        try { list = JSON.parse(localStorage.getItem('arbo-wish') || '[]'); } catch (e) {}
        if (list.indexOf(id) === -1) list.push(id);
        localStorage.setItem('arbo-wish', JSON.stringify(list));
        btn.textContent = 'Saved';
      });
    });

    var promo = document.querySelector('[data-ak-promo]');
    if (promo) {
      promo.addEventListener('submit', function (e) {
        e.preventDefault();
        var code = (promo.querySelector('input[name="discount"]') || {}).value || '';
        code = code.trim();
        if (code) window.location.href = '/checkout?discount=' + encodeURIComponent(code);
      });
    }
  });

  function initCartPage() {
    var root = document.querySelector('[data-ak-cart]');
    if (!root || !root.querySelector('[data-ak-line]')) return;

    var inFlight = false;
    var pending = null;

    function setBusy(on) {
      root.classList.toggle('is-busy', on);
    }

    function renderCart(cart) {
      updateCartCount(cart.item_count || 0);

      if (!cart.item_count) {
        window.location.reload();
        return;
      }

      var byKey = {};
      (cart.items || []).forEach(function (item) {
        byKey[item.key] = item;
      });

      root.querySelectorAll('[data-ak-line]').forEach(function (row) {
        var key = row.getAttribute('data-key');
        var item = byKey[key];
        if (!item) {
          row.remove();
          return;
        }
        var qtyInput = row.querySelector('[data-ak-qty]');
        if (qtyInput && document.activeElement !== qtyInput) {
          qtyInput.value = String(item.quantity);
        }
        var linePrice = row.querySelector('[data-ak-line-price]');
        if (linePrice) {
          linePrice.setAttribute('data-cents', String(item.final_line_price));
          linePrice.textContent = formatMoney(item.final_line_price);
        }
      });

      var countEl = root.querySelector('[data-ak-summary-count]');
      if (countEl) {
        var n = cart.item_count;
        countEl.textContent = 'Order Summary · ' + n + ' item' + (n === 1 ? '' : 's');
      }

      var subtotalEl = root.querySelector('[data-ak-subtotal]');
      if (subtotalEl) {
        subtotalEl.setAttribute('data-cents', String(cart.items_subtotal_price));
        subtotalEl.textContent = formatMoney(cart.items_subtotal_price);
      }

      var totalEl = root.querySelector('[data-ak-total]');
      if (totalEl) {
        totalEl.setAttribute('data-cents', String(cart.total_price));
        totalEl.textContent = formatMoney(cart.total_price);
      }
    }

    function flushChange() {
      if (inFlight || !pending) return;
      var req = pending;
      pending = null;
      inFlight = true;
      setBusy(true);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: req.key, quantity: Math.max(0, req.quantity) })
      })
        .then(parseJsonResponse)
        .then(function (cart) {
          renderCart(cart);
        })
        .catch(function () {
          window.location.reload();
        })
        .then(function () {
          inFlight = false;
          if (pending) flushChange();
          else setBusy(false);
        });
    }

    function changeLine(key, quantity) {
      if (!key) return;
      pending = { key: key, quantity: quantity };
      flushChange();
    }

    root.querySelectorAll('[data-ak-line]').forEach(function (row) {
      var key = row.getAttribute('data-key');
      var qtyInput = row.querySelector('[data-ak-qty]');
      var removeBtn = row.querySelector('[data-ak-remove]');

      if (qtyInput) {
        var timer = null;
        qtyInput.addEventListener('change', function () {
          var qty = parseInt(qtyInput.value, 10);
          if (isNaN(qty) || qty < 0) qty = 0;
          qtyInput.value = String(qty);
          changeLine(key, qty);
        });
        qtyInput.addEventListener('input', function () {
          clearTimeout(timer);
          timer = setTimeout(function () {
            var qty = parseInt(qtyInput.value, 10);
            if (isNaN(qty) || qty < 0) return;
            changeLine(key, qty);
          }, 450);
        });
      }

      if (removeBtn) {
        removeBtn.addEventListener('click', function () {
          changeLine(key, 0);
        });
      }
    });

    var checkout = root.querySelector('[data-ak-checkout]');
    if (checkout) {
      checkout.addEventListener('click', function (e) {
        e.preventDefault();
        window.location.href = '/checkout';
      });
    }
  }

  function initExitPopup() {
    var root = document.querySelector('[data-ah-exit]');
    if (!root) return;

    var STORAGE = 'arbo-exit-popup-v4';
    var SESSION_DISMISS = 'arbo-exit-dismiss-session';
    var COOLDOWN_MS = 1000 * 60 * 60 * 24;
    var prizes = {
      a: { label: '10% off your order', code: 'ARBO10', name: 'Maroon bag' },
      b: { label: '12% off your order', code: 'ARBO12', name: 'Black bag' },
      c: { label: '15% off your order', code: 'ARBO15', name: 'Tan bag' }
    };

    function blockedPage() {
      var p = window.location.pathname || '';
      return p.indexOf('/checkout') === 0 || p.indexOf('/cart') === 0;
    }

    function dismissedThisSession() {
      try {
        return sessionStorage.getItem(SESSION_DISMISS) === '1';
      } catch (e) {
        return false;
      }
    }

    function alreadyShown() {
      if (dismissedThisSession()) return true;
      try {
        var raw = localStorage.getItem(STORAGE);
        if (!raw) return false;
        var data = JSON.parse(raw);
        if (data && data.won && data.until && Date.now() < data.until) return true;
      } catch (e) {}
      return false;
    }

    function markShown() {
      try {
        localStorage.setItem(STORAGE, JSON.stringify({ won: true, until: Date.now() + COOLDOWN_MS }));
      } catch (e) {}
    }

    function markDismissedSession() {
      try {
        sessionStorage.setItem(SESSION_DISMISS, '1');
      } catch (e) {}
    }

    function shuffle(arr) {
      var a = arr.slice();
      for (var i = a.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = a[i];
        a[i] = a[j];
        a[j] = t;
      }
      return a;
    }

    function buildDeck() {
      return shuffle(['a', 'a', 'a', 'b', 'b', 'b', 'c', 'c', 'c']);
    }

    var deck = buildDeck();
    var counts = { a: 0, b: 0, c: 0 };
    var flipCount = 0;
    var won = false;
    var opened = false;
    var armed = false;

    var grid = root.querySelector('[data-ah-exit-grid]');
    var game = root.querySelector('[data-ah-exit-game]');
    var stepGame = root.querySelector('[data-ah-exit-step="game"]');
    var stepClaim = root.querySelector('[data-ah-exit-step="claim"]');
    var choices = root.querySelector('[data-ah-exit-choices]');
    var claimCode = root.querySelector('[data-ah-exit-claim-code]');
    var dialog = root.querySelector('.ah-exit__dialog');
    var currentPrize = prizes.a;

    function prizeMarkup(type) {
      return '<span class="ah-exit__prize ah-exit__prize--' + type + '" aria-hidden="true">👜</span>';
    }

    function pickWinType() {
      var best = 'a';
      if (counts.b > counts[best]) best = 'b';
      if (counts.c > counts[best]) best = 'c';
      return best;
    }

    function showStep(name) {
      if (stepGame) stepGame.hidden = name !== 'game';
      if (stepClaim) stepClaim.hidden = name !== 'claim';
      if (dialog) dialog.classList.toggle('is-claim', name === 'claim');
    }

    function renderGrid() {
      if (!grid) return;
      deck = buildDeck();
      counts = { a: 0, b: 0, c: 0 };
      flipCount = 0;
      won = false;
      currentPrize = prizes.a;
      grid.innerHTML = '';
      deck.forEach(function (type, idx) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ah-exit__card';
        btn.setAttribute('data-ah-exit-card', '');
        btn.setAttribute('data-type', type);
        btn.setAttribute('data-idx', String(idx));
        btn.setAttribute('aria-label', 'Reveal bag ' + (idx + 1));
        btn.innerHTML =
          '<span class="ah-exit__card-face ah-exit__card-face--back"></span>' +
          '<span class="ah-exit__card-face ah-exit__card-face--front">' + prizeMarkup(type) + '</span>';
        grid.appendChild(btn);
      });
    }

    function showWin(type) {
      currentPrize = prizes[type] || prizes.a;
      var off = root.querySelector('[data-ah-exit-win-off]');
      var code = root.querySelector('[data-ah-exit-code]');
      if (off) off.textContent = currentPrize.label.replace(' your order', '');
      if (code) code.textContent = currentPrize.code;
      if (choices) choices.hidden = false;
      if (claimCode) claimCode.hidden = true;
      root.querySelectorAll('[data-ah-exit-choice]').forEach(function (btn) {
        btn.classList.remove('is-selected');
        btn.disabled = false;
      });
      showStep('claim');
      won = true;
      markShown();
    }

    function onCardClick(btn) {
      if (btn.classList.contains('is-open') || won) return;
      var type = btn.getAttribute('data-type');
      btn.classList.add('is-open');
      flipCount += 1;
      counts[type] = (counts[type] || 0) + 1;

      var winType = counts[type] >= 3 ? type : pickWinType();
      if (counts[winType] >= 3 || flipCount >= 3) {
        setTimeout(function () { showWin(winType); }, 500);
      }
    }

    function openPopup() {
      if (opened || blockedPage() || alreadyShown()) return;
      opened = true;
      renderGrid();
      if (game) game.hidden = false;
      if (choices) choices.hidden = false;
      if (claimCode) claimCode.hidden = true;
      showStep('game');
      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(function () {
        root.classList.add('is-open');
      });
      document.documentElement.style.overflow = 'hidden';
      if (dialog) dialog.focus();
    }

    function closePopup() {
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      setTimeout(function () {
        if (!root.classList.contains('is-open')) root.hidden = true;
      }, 320);
      markDismissedSession();
      if (won) markShown();
    }

    root.querySelectorAll('[data-ah-exit-close]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        closePopup();
      });
    });

    if (grid) {
      grid.addEventListener('click', function (e) {
        var card = e.target.closest('[data-ah-exit-card]');
        if (card) onCardClick(card);
      });
    }

    root.querySelectorAll('[data-ah-exit-choice]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-ah-exit-choice]').forEach(function (b) {
          b.classList.toggle('is-selected', b === btn);
          b.disabled = true;
        });
        if (choices) choices.hidden = true;
        if (claimCode) claimCode.hidden = false;
        var codeEl = root.querySelector('[data-ah-exit-code]');
        if (codeEl && currentPrize) codeEl.textContent = currentPrize.code;
      });
    });

    var copyBtn = root.querySelector('[data-ah-exit-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var codeEl = root.querySelector('[data-ah-exit-code]');
        var text = codeEl ? codeEl.textContent : '';
        if (!text) return;
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(function () {
            copyBtn.textContent = 'Copied';
            setTimeout(function () { copyBtn.textContent = 'Copy'; }, 1600);
          });
        }
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) closePopup();
    });

    function shouldTriggerExit(e) {
      if (!e || typeof e.clientY !== 'number') return true;
      return e.clientY <= 15;
    }

    function tryExitOpen(e) {
      if (opened || blockedPage() || alreadyShown()) return;
      if (!shouldTriggerExit(e)) return;
      openPopup();
    }

    function armExitIntent() {
      if (armed || blockedPage() || alreadyShown()) return;
      armed = true;

      document.addEventListener('mouseout', function (e) {
        var rel = e.relatedTarget || e.toElement;
        if (rel) return;
        tryExitOpen(e);
      });

      document.documentElement.addEventListener('mouseleave', function (e) {
        tryExitOpen(e);
      });

      document.body.addEventListener('mouseleave', function (e) {
        tryExitOpen(e);
      });

      var lastY = 999;
      document.addEventListener('mousemove', function (e) {
        lastY = e.clientY;
      }, { passive: true });
      document.addEventListener('mouseleave', function () {
        if (lastY <= 12) tryExitOpen({ clientY: 0 });
      });
    }

    renderGrid();

    if (/[?&]exit=1(?:&|$)/.test(window.location.search)) {
      setTimeout(function () { openPopup(); }, 600);
      return;
    }

    if (blockedPage() || alreadyShown()) return;

    setTimeout(armExitIntent, 2000);

    var touch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    if (touch) {
      setTimeout(function () {
        if (!opened && !alreadyShown() && !blockedPage()) openPopup();
      }, 45000);
    }
  }
})();
